import * as React from 'react';
import { getConfig } from '../config';
import { useShowTag } from '../hooks/ad';
import { getBannerProximityByPlacementId } from '../utils/banner-proximity';
import { PlacementId } from '../../shared/types/ast';
import { useMemo } from 'react';
import { displayAdsLog } from '../utils/debug';

export type Props = {
    id: string;
    targetId: string;
    pageType?: string;
    className?: string;
    deviceType?: string;
    vertical?: string;
    grid?: boolean;
    adSize?: {
        width: number;
        height: number;
    };
    slotAd?: boolean;
};

const BannerAd = ({ slotAd, children, id, className }) =>
    slotAd ? (
        <slot name={`${id}_slot`} className={className} id={id}>
            {children}
        </slot>
    ) : (
        <div className={className} id={id}>
            {children}
        </div>
    );

export function Banner(props: Props) {
    const {
        id,
        targetId,
        pageType,
        className = 'grid overflow-hidden relative transition-all outline-none col-span-full',
        adSize,
        slotAd,
    } = props;

    displayAdsLog(`Render Banner ${id} targetId: ${targetId}`);

    const { subvertical } = getConfig();
    const noFabricOnPage = subvertical === 'prepackage';

    const { proximity = 0, threshold = 0.0 } = useMemo(() => {
        return getBannerProximityByPlacementId(id as PlacementId, adSize);
    }, [id, adSize]);

    useShowTag(targetId, proximity, threshold);

    if (pageType && pageType === 'object') {
        // Rendered from objectpages-podium already
        return null;
    }
    let containerClassName = className;
    let boardClassName = 'inline mx-auto';

    if (noFabricOnPage) {
        containerClassName =
            'ads__unit ads__unit--banner ads__unit--fullwidth banners';
        boardClassName = `inline-container ${id}-inline-container`;
    }

    return (
        <div id={`${targetId}-container`} className={containerClassName}>
            <BannerAd id={targetId} className={boardClassName} slotAd={slotAd}>
                <span className="ad-info-wrap">
                    <div
                        id={`${targetId}-button`}
                        className="ad-info"
                        style={{ maxWidth: 26, maxHeight: 26 }}
                    />
                </span>
            </BannerAd>
        </div>
    );
}
